import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { Collection } from "@/components/Collection";
import { Manifesto } from "@/components/Manifesto";
import { Activities } from "@/components/Activities";
import { Events } from "@/components/Events";
import { Membership } from "@/components/Membership";
import { Testimonial } from "@/components/Testimonial";
import { Reviews } from "@/components/Reviews";
import { Visit } from "@/components/Visit";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Collection />
        <Manifesto />
        <Activities />
        <Events />
        <Membership />
        <Testimonial />
        <Reviews />
        <Visit />
      </main>
      <Footer />
    </>
  );
}
